<!-- 产品解决方案／群星金融N+1供应链金融产品 -->
<template>
  <div id="about">
    <header>
      <div class="cover">
        <h1>
          公司介绍
          <span>什么是供应链金融
            <div class="dialog">
              <h3>什么是供应链金融？</h3>
              <p>通过银行将核心企业和上下游企业联系在一起，把单个企业的不可控风险转变为供应链企业整体的可控风险，通过立体获取各类信息，将风险控制在最低的金融服务。简单地说，就是提供灵活运用的金融产品和服务的一种融资模式,即把资金作为供应链的一个溶剂，增加其流动性。</p>
            </div>
          </span>
        </h1>
        <h2>一家专注于供应链金融长尾的互联网交易平台</h2>
        <h3>群星金融成立于2013年6月，六年来一直专注于供应链金融长尾市场。<br>群星金融以技术为第一驱动力，通过互联网技术与大数据风控，<br>让沉积于中小企业的应收账款获得流动性，全面降低中小企业融资成本的同时，<br>为参与交易的核心企业，金融机构等多方主体创造价值。</h3>
        <div class="info">
          <img src="/imgs/portal/about/moneyflow@2x.png" alt="icon">
          <span>让核心企业的经营性现金流发挥最大效率的作用</span>
          <aside></aside>
        </div>
        <div class="info rongzi">
          <img src="/imgs/portal/about/rongzi@2x.png" alt="icon">
          <span>让中小供应商享受货款现结解决融资难的问题</span>
          <aside></aside>
        </div>
        <div class="info index">
          <img src="/imgs/portal/about/index@2x.png" alt="icon">
          <span>让银行享受优质企业资源批量解决支小指标</span>
        </div>
      </div>
    </header>
    <section>
      <h1>群星金融发展历程</h1>
      <div class="swiper">
        <span class="left-arrow" @click="slidRight = false"></span>
        <div class="swiper-cover">
          <ul :class="slidRight?'slidRight':''">
            <li>
              <div class="small">2013年</div>
              <div class="space"></div>
              <div class="big">
                <img src="/imgs/portal/about/2013.6@2x.png" alt="icon">
                <strong>2013/6</strong>
                <span style="text-align: center;">群星金融网<br>成立并上线</span>
              </div>
            </li>
            <li style="background:#709df2;">
              <img src="/imgs/portal/about/2013.10@2x.png" alt="icon">
              <strong>2013/10</strong>
              <span>与交通银行浙江省分行就中小企业产业链融资签署战略协议，推出产品"E贷链"</span>
            </li>
            <li>
              <div class="big">
                <img src="/imgs/portal/about/2013.11@2x.png" alt="icon">
                <strong>2013/11</strong>
                <span>与联想集团、物美集团签署合作协议</span>
              </div>
              <div class="space"></div>
              <div class="small">2014年</div>
            </li>
            <li style="background:#0c70b6;">
              <img src="/imgs/portal/about/2014.8@2x.png" alt="icon">
              <strong>2014/8</strong>
              <span>获得北极光创投领投，华创资本跟投的500万美元A轮融资</span>
            </li>
            <li>
              <div class="big" style="background:#3b9ce0;">
                <img src="/imgs/portal/about/2014.9@2x.png" alt="icon" style="width: 76px;">
                <strong>2014/9</strong>
                <span>海尔日日顺项目上线放款</span>
              </div>
              <div class="space"></div>
              <div class="small">2015年</div>
            </li>
            <li style="background:#478afd;">
              <img src="/imgs/portal/about/2015.4@2x.png" alt="icon">
              <strong>2015/4</strong>
              <span>获得由华创、IDG的2000万美元B轮融资</span>
            </li>
            <li>
              <div class="small">2016年</div>
              <div class="space"></div>
              <div class="big">
                <img src="/imgs/portal/about/2016.4@2x.png" alt="icon" style="margin: 20px auto 10px;">
                <strong>2016/4</strong>
                <span>获得商业保理专业委员会颁发的"创新奖"</span>
              </div>
            </li>
            <li style="background:#709df2;">
              <img src="/imgs/portal/about/2016.5@2x.png" alt="icon">
              <strong>2016/5</strong>
              <span>获得由曦域资本领投，深圳前海母基金跟投的1.5亿元B+轮融资</span>
              </li>
            <li style="background:#0c70b6;">
              <img src="/imgs/portal/about/2016.7@2x.png" alt="icon">
              <strong>2016/7</strong>
              <span>累计提供融资突破100亿</span>
            </li>
            <li style="background:#1f5dea;">
              <img src="/imgs/portal/about/2016.4@2x.png" alt="icon">
              <strong>2016/11</strong>
              <span>荣获"2016德勤-华兴中国明日之星"、第一财经金融价值榜"最佳平台科技金融公司"</span>
            </li>
            <li style="background:#3b9ce0;">
              <img src="/imgs/portal/about/2016.12@2x.png" alt="icon" style="margin-bottom:32px;width:50px;">
              <strong>2016/12</strong>
              <span>"虚拟财务公司"产品发布，同期荣获"创业黑马TOP100-中国最具潜力创业公司"</span>
            </li>
            <li>
              <div class="small">2017年</div>
              <div class="space"></div>
              <div class="big">
                <img src="/imgs/portal/about/2016.4@2x.png" alt="icon" style="margin: 23px auto 10px;">
                <strong>2017/3</strong>
                <span>获联商网"2016年度新零售十佳服务商"</span>
              </div>
            </li>
            <li style="background:#709df2;">
              <img src="/imgs/portal/about/2017.6@2x.png" alt="icon" style="width:89px;margin: 65px auto 43px;">
              <strong>2017/6</strong>
              <span>荣获《银行家》"十佳互联网金融创新奖"</span>
            </li>
            <li style="background:#3b9ce0;">
              <img src="/imgs/portal/about/2016.4@2x.png" alt="icon">
              <strong>2017/7</strong>
              <span>获第六届中国财经峰会"2017最具成长价值讲"</span>
            </li>
            <li>
              <div class="small">2018年</div>
              <div class="space"></div>
              <div class="big">
                <img src="/imgs/portal/about/2016.4@2x.png" alt="icon" style="margin: 20px auto 8px;">
                <strong style="margin-bottom: 4px;">2018/3</strong>
                <span style="margin-top: 0;">年度金融科技介甫奖—最具影响力供应链金融服务机构</span>
              </div>
            </li>
          </ul>
        </div>
        <span class="right-arrow" @click="slidRight = true"></span>
      </div>
      <h1>荣誉奖项</h1>
      <div class="cover">
        <el-carousel :loop="false" :interval='0' :arrow='"always"' type="card" height="430px" indicator-position="none">
          <el-carousel-item>
            <img src="/imgs/portal/about/cup08@2x.png" alt="img" style="width: 67px;">
            <h1>2016年04月</h1>
            <h2>首届中国商业保理行业创新奖</h2>
            <h3>中国服务贸易协会商业保理专业委员会颁发</h3>
          </el-carousel-item>
          <el-carousel-item>
            <img src="/imgs/portal/about/cup07@2x.png" alt="img" style="width: 86px;">
            <h1>2016年11月</h1>
            <h2>2016德勤-华兴中国明日之星</h2>
            <h3>德勤中国、华兴资本颁发</h3>
          </el-carousel-item>
          <el-carousel-item>
            <img src="/imgs/portal/about/cup06@2x.png" alt="img" style="width: 149px;">
            <h1>2016年11月</h1>
            <h2>第一财经金融价值榜<br>“最佳平台科技金融公司”</h2>
            <h3>第一财经颁发</h3>
          </el-carousel-item>
          <el-carousel-item>
            <img src="/imgs/portal/about/cup05@2x.png" alt="img" style="width: 141px;">
            <h1>2016年12月</h1>
            <h2>2016创业黑马TOP100<br>“中国最具潜力创业公司”</h2>
            <h3>创业黑马颁发</h3>
          </el-carousel-item>
          <el-carousel-item>
            <img src="/imgs/portal/about/cup04@2x.png" alt="img" style="width: 52px;">
            <h1>2017年03月</h1>
            <h2>2016年度十佳新零售服务商</h2>
            <h3>联商网颁发</h3>
          </el-carousel-item>
          <el-carousel-item>
            <img src="/imgs/portal/about/cup03@2x.png" alt="img" style="width: 80px;">
            <h1>2017年06月</h1>
            <h2>十佳互联网金融创新奖</h2>
            <h3>《银行家》颁发</h3>
          </el-carousel-item>
          <el-carousel-item>
            <img src="/imgs/portal/about/cup02@2x.png" alt="img" style="width: 124px;">
            <h1>2017年07月</h1>
            <h2>2017最具成长价值奖</h2>
            <h3>第六届中国财经峰会颁发</h3>
          </el-carousel-item>
          <el-carousel-item>
            <img src="/imgs/portal/about/cup01@2x.png" alt="img" style="width: 246px;">
            <h1>2017年09月</h1>
            <h2>金惠奖·普惠金融优秀解决方案</h2>
            <h3>中国普惠金融大会颁发</h3>
          </el-carousel-item>
          <el-carousel-item>
            <img src="/imgs/portal/about/cup09.png" alt="img" style="width: 136px;">
            <h1>2018年03月</h1>
            <h2>年度金融科技介甫奖</h2>
            <h3>—最具影响力供应链金融服务机构</h3>
          </el-carousel-item>
        </el-carousel>
      </div>
      <h1>企业文化</h1>
      <div class="life">
        <span>
          <div>我们的圣诞派对<br>派发圣诞礼物</div>
        </span>
        <span>
          <div>我们的群星漫画集<br>“群小星来啦”</div>
        </span>
        <span>
          <div>我们的季度总结大会<br>CEO演讲</div>
        </span>
        <span>
          <div>我们的户外旅途<br>三清山之旅</div>
        </span>
        <span>
          <div>我们的周年庆典<br>活动庆典</div>
        </span>
        <span>
          <div>我们的公司内刊<br>星迹杂志</div>
        </span>
        <span>
          <div>我们的群星峰会<br>活动现场</div>
        </span>
        <span>
          <div>我们的业余生活<br>群星电竞比赛</div>
        </span>
      </div>
      <div class="join">
        <span @click="topage('news')">了解更多</span>
        <div></div>
        <span @click="topage('join')">加入我们</span>
      </div>
    </section>
    <portal-footer></portal-footer>
  </div>
</template>

<script>
import Footer from './Footer'

export default {
  data () {
    return {
      slidRight: false
    }
  },
  created () {},
  methods: {
    topage (way) {
      this.$router.push(way)
    }
  },
  components: {
    'portal-footer': Footer
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '~@/assets/css/utils';

#about {
  margin-top: 96px;
  background: #f2f2f2;
  header {
    height: 612px;
    background: url(/imgs/portal/about/bg@2x.png) center center no-repeat;
    background-size: cover;
    color: #ffffff;
    .cover {
      width: 1000px;
      margin: 0 auto;
      h1 {
        font-weight: normal;
        font-family: PingFangSC-Regular;
        font-size: 24px;
        color: #ffffff;
        letter-spacing: 0.5px;
        line-height: 24px;
        text-align: left;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        padding-bottom: 10px;
        margin: 0;
        padding-top: 24px;
        span {
          float: right;
          display: block;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0.5px;
          text-align: right;
          line-height: 14px;
          margin-top: 5px;
          padding: 3px 0 3px 26px;
          background: url(/imgs/portal/products/attention@2x.png) left center
            no-repeat;
          background-size: 20px;
          cursor: pointer;
          position: relative;
          .dialog {
            display: none;
            position: absolute;
            right: 0;
            top: 30px;
            z-index: 1;
            color: #333333;
            opacity: 0.96;
            background: #ffffff;
            border-radius: 4px;
            width: 528px;
            height: 190px;
            text-align: left;
            padding: 42px 49px 40px;
            box-sizing: border-box;
            h3 {
              color:#333333;
              font-family: PingFangSC-Medium;
              font-size: 16px;
              letter-spacing: 0.5px;
              line-height: 16px;
              font-weight: 600;
              margin: 0 0 20px;
            }
            p {
              font-family: PingFangSC-Regular;
              font-size: 12px;
              letter-spacing: 0.38px;
              text-align: justify;
              line-height: 18px;
              margin: 0;
            }
            h4 {
              margin: 10px 0 0;
              padding: 3px 0 6px;
              font-family: PingFangSC-Medium;
              font-size: 14px;
              color: #1f5dea;
              letter-spacing: 0.44px;
              line-height: 16px;
              text-align: left;
              padding-left: 23px;
              background: url(/imgs/portal/products/example@2x.png) -12px center
                no-repeat;
              background-size: 37px;
            }
            h5 {
              margin: 0;
              font-family: PingFangSC-Regular;
              color: #41434b;
              text-align: justify;
              font-weight: normal;
              overflow: hidden;
              i {
                font-style: normal;
                font-size: 12px;
                background: #dfe9ff;
                letter-spacing: 0.38px;
                display: block;
                float: left;
                margin-bottom: 6px;
              }
            }
            strong {
              color: #1f5dea;
              margin-top: 12px;
              display: inline-block;
            }
          }
          &:hover .dialog {
            display: block;
          }
        }
      }
      h2 {
        font-family: PingFangSC-Semibold;
        font-size: 40px;
        color: #ffffff;
        letter-spacing: 1.25px;
        text-align: center;
        line-height: 40px;
        margin: 49px 0 32px;
        font-weight: normal;
      }
      h3 {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0.38px;
        text-align: center;
        line-height: 26px;
        font-weight: normal;
        margin-bottom: 80px;
      }
      .info {
        display: inline-block;
        vertical-align: top;
        width: 322px;
        position: relative;
        img {
          width: 64px;
          display: block;
          margin: 0 auto 30px;
        }
        &.rongzi {
          img {
            width: 58px;
            margin: 5px auto 42px;
          }
        }
        &.index {
          img {
            width: 61px;
            margin: 5px auto 42px;
          }
          span {
            width: 160px;
          }
        }
        span {
          display: block;
          width: 173px;
          margin: 0 auto;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0.33px;
          text-align: center;
          line-height: 24px;
        }
        aside {
          opacity: 0.2;
          width: 1px;
          height: 126px;
          background: #fff;
          position: absolute;
          right: 0;
          top: 10px;
        }
      }
    }
  }
  section {
    background: #ffffff;
    padding: 70px 0;
    min-width: 1000px;
    h1 {
      font-weight: normal;
      font-family: PingFangSC-Medium;
      font-size: 38px;
      color: #222222;
      letter-spacing: 1.19px;
      text-align: center;
      line-height: 38px;
      margin: 0 auto 50px;
    }
    .swiper {
      width: 1060px;
      margin: 0 auto 80px;
      overflow: hidden;
      .left-arrow{
        background-image: url('/imgs/portal/about/el-icon-arrow-left@2x.png');
      }
      .right-arrow{
        background-image: url('/imgs/portal/about/el-icon-arrow-right@2x.png');
      }
      .left-arrow,
      .right-arrow {
        float: left;
        display: block;
        width: 36px;
        height: 36px;
        margin-top: 116px;
        border-radius: 50%;
        cursor: pointer;
        background-color: rgba(31,45,61,.11);
        background-size: 6px 12px;
        background-position: center;
        background-repeat: no-repeat;
        &:hover {
          background-color: rgba(31,45,61,.23);
        }
      }
      .swiper-cover {
        display: block;
        overflow: hidden;
        float: left;
        width: 968px;
        height: 268px;
        margin: 0 5px 0 10px;
        ul {
          width: 1815px;
          transition-duration: 300ms;
          &.slidRight {
            transition-duration: 300ms;
            transform: translate3d(-845px, 0px, 0px);
          }
        }
        li {
          display: block;
          float: left;
          width: 115px;
          height: 268px;
          margin-right: 6px;
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #ffffff;
          letter-spacing: 0;
          text-align: center;
          line-height: 17px;
          overflow: hidden;
          img {
            width: 40px;
            display: block;
            margin: 56px auto 22px;
          }
          strong {
            font-weight: normal;
            display: block;
            font-size: 14px;
            letter-spacing: 0.53px;
            line-height: 14px;
            margin-bottom: 16px;
          }
          span {
            width: 88px;
            display: block;
            font-size: 12px;
            margin: 10px auto 0;
            text-align: justify;
            letter-spacing: 0;
            line-height: 17px;
          }
          .small {
            background: #181e31;
            width: 100%;
            height: 92px;
            font-family: PingFangSC-Regular;
            font-size: 18px;
            color: #ffffff;
            letter-spacing: 0.68px;
            line-height: 92px;
          }
          .space {
            height: 6px;
            width: 100%;
          }
          .big {
            background: #1f5dea;
            width: 100%;
            height: 170px;
            overflow: hidden;
            img {
              margin: 28px auto 22px;
            }
            strong {
              margin-bottom: 10px;
            }
          }
        }
      }
    }
    .cover {
      width: 1000px;
      margin: 0 auto 80px;
      overflow: hidden;
      .el-carousel {
        text-align: center;
        padding-top: 10px;
      }
      .el-carousel__item {
        background: #ffffff;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.27);
        border-radius: 6px;
        width: 340px;
        height: 400px;
        left: 80px;
        img {
          display: block;
          margin: 50px auto 20px;
        }
        h1 {
          font-family: PingFangSC-Regular;
          font-size: 18px;
          color: #222222;
          letter-spacing: 0.68px;
          text-align: center;
          line-height: 18px;
          font-weight: normal;
          margin: 0 0 18px;
        }
        h2,
        h3 {
          font-weight: normal;
          margin: 0;
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #333333;
          letter-spacing: 0.58px;
          text-align: center;
          line-height: 16px;
          margin-bottom: 30px;
        }
      }
    }
    .life {
      overflow: hidden;
      // width: 1280px;
      margin: 0 auto;
      margin-bottom: 70px;
      span {
        width: 25%;
        display: block;
        float: left;
        background: url(/imgs/portal/about/zhaopian1@2x.png) center center no-repeat;
        background-size: 100% 100%;
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: #ffffff;
        letter-spacing: 0.5px;
        text-align: center;
        line-height: 28px;
        box-sizing: border-box;
        margin: 0;
        cursor: pointer;
        div {
          width: 100%;
          background: rgba(0, 0, 0, 0.5);
          padding: 41% 0;
          opacity: 1;
          transition: opacity 0.1s ease-out;
          &:hover {
            opacity: 0;
          }
        }
      }
      span:nth-child(2){
        background-image: url(/imgs/portal/about/zhaopian2@2x.png);
      }
      span:nth-child(3){
        background-image: url(/imgs/portal/about/zhaopian3@2x.png);
      }
      span:nth-child(4){
        background-image: url(/imgs/portal/about/zhaopian4@2x.png);
      }
      span:nth-child(5){
        background-image: url(/imgs/portal/about/zhaopian5@2x.png);
      }
      span:nth-child(6){
        background-image: url(/imgs/portal/about/zhaopian6@2x.png);
      }
      span:nth-child(7){
        background-image: url(/imgs/portal/about/zhaopian7@2x.png);
      }
      span:nth-child(8){
        background-image: url(/imgs/portal/about/zhaopian8@2x.png);
      }
    }
    .join {
      text-align: center;
      font-family:PingFangSC-Regular;
      font-size:22px;
      color:#0070c9;
      letter-spacing:1px;
      text-align:center;
      span{
        display: inline-block;
        vertical-align: top;
        border:1px solid #1f5dea;
        border-radius:4px;
        width:283px;
        height:56px;
        line-height:56px;
        cursor: pointer;
      }
      div{
        width: 174px;
        height: 1px;
        display: inline-block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// About.vue?558c1fc6